import { render, staticRenderFns } from "./PaxRow.vue?vue&type=template&id=30a66d3c&scoped=true"
import script from "./PaxRow.vue?vue&type=script&lang=js"
export * from "./PaxRow.vue?vue&type=script&lang=js"
import style0 from "./PaxRow.vue?vue&type=style&index=0&id=30a66d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a66d3c",
  null
  
)

export default component.exports